import type { TContentBlockBase } from '@onesource/schemas';

import { ResourceCard } from './resource-card';

/** Link block tile — opens the target in a new tab instead of navigating. */
export const RedirectCard = ({ block }: { block: TContentBlockBase }) => {
  const handleOpen = () => {
    if (block.redirectUrl) {
      window.open(block.redirectUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ResourceCard
      block={block}
      onClick={handleOpen}
      caption={block.title || 'Redirect'}
      bannerUrl={block.textBannerUrl}
    />
  );
};
